import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
//import Box from '@material-ui/core/Box';
import InfoChartMap from './InfoChartMap';
import NoDataDialog from './NoDataDialog';
import { reportReset } from '../actions/index';
import useLoadReport from '../hooks/useLoadReport';

const FuelView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { viewName } = useParams();

  const data = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return {
      type: 'fuel',
      objectId: queryParams.get('object'),
      start: moment(queryParams.get('start')),
      end: moment(queryParams.get('end')),
      params: queryParams.get('params')
        ? JSON.parse(queryParams.get('params'))
        : null,
    };
  }, [location.search]);

  const loadReport = useLoadReport(data, data.params);

  React.useEffect(() => {
    if (viewName === 'fuel') {
      loadReport.loadAsync().then(() => {
        // Report loaded successfully
      });
    }
  }, [loadReport, viewName]);

  const onConfirm = () => {
    history.goBack();
    dispatch(reportReset('fuel'));
  };

  const fuelReport = useSelector(state => state.report.fuel);
  const errorDialog = fuelReport.status === 'nodata';
  const reportType =
    fuelReport.status === 'nodata' || fuelReport.status === 'loading'
      ? 'loading'
      : 'fuel';

  return (
    <React.Fragment>
      {errorDialog && (
        <NoDataDialog
          open={true}
          onClose={onConfirm}
          objectName={fuelReport.objectName}
          startDate={fuelReport.start}
          endDate={fuelReport.end}
        />
      )}
      <InfoChartMap type={reportType} object={fuelReport} />
    </React.Fragment>
  );
};
// ViewStack.propTypes = {
//   views: PropTypes.object,
//   show: PropTypes.string,
// };

export default FuelView;
